import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceindapoli() {



const cardData = {
  keyword: " Cab Service in Dapoli  ",

"headingDescription": "SRS Cab Service offers Cab Service in Dapoli, providing comfortable, reliable, and scenic travel solutions for tourists, families, and local residents. Whether you are planning a beach getaway, sightseeing tour, local travel, or an outstation journey, our well-maintained vehicles and experienced drivers ensure a smooth and enjoyable ride. With flexible booking options, transparent pricing, and 24/7 support, SRS Cab Service makes exploring Dapoli and nearby coastal destinations easy and stress-free.",
"topPlaces": [
  {
    "title": "Murud Beach",
    "description": "Murud Beach is a serene and clean beach near Dapoli, perfect for relaxation and water activities. Travelers using Cab Service in Dapoli from SRS Cab Service often visit for peaceful coastal experiences."
  },
  {
    "title": "Karde Beach",
    "description": "Karde Beach is known for its calm waters and dolphin sightings. Visitors using SRS Cab Service often include it in their itinerary for scenic beauty and tranquility."
  },
  {
    "title": "Ladghar Beach",
    "description": "Ladghar Beach, also known as Tamas Teertha, is famous for its reddish sand and peaceful ambiance. Travelers using SRS Cab Service often visit for a unique beach experience."
  },
  {
    "title": "Suvarnadurg Fort",
    "description": "Suvarnadurg Fort is a historic sea fort showcasing Maratha history. Visitors using SRS Cab Service often explore this destination for its heritage and coastal views."
  },
  {
    "title": "Panhalekaji Caves",
    "description": "Panhalekaji Caves are ancient rock-cut caves surrounded by lush greenery. Travelers using SRS Cab Service often visit for history and nature exploration."
  },
  {
    "title": "Parshuram Bhumi",
    "description": "Parshuram Bhumi is a spiritual site dedicated to Lord Parshuram. Visitors using SRS Cab Service often visit for religious significance and panoramic views."
  },
  {
    "title": "Anjarle Beach",
    "description": "Anjarle Beach is a scenic coastal destination known for its peaceful environment. Travelers using SRS Cab Service often visit for relaxation and photography."
  },
  {
    "title": "Kadyavarcha Ganpati Temple",
    "description": "Kadyavarcha Ganpati Temple is a famous hilltop temple offering sea views. Visitors using SRS Cab Service often seek blessings and enjoy the surroundings."
  },
  {
    "title": "Dabhol Port",
    "description": "Dabhol Port is a historic port town near Dapoli. Travelers using SRS Cab Service often explore it for its coastal charm and history."
  },
  {
    "title": "Harnai Fish Market",
    "description": "Harnai Fish Market is one of the most vibrant coastal markets. Visitors using SRS Cab Service often visit early morning to experience local culture and seafood trade."
  }
],



services: [
{
name: "Best Cab Service in Dapoli",
description: "Best cab service in Dapoli offers reliable transportation for beach trips and sightseeing tours. Customers can book cabs for local and outstation travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Cheap Cab Service Dapoli",
description: "Cheap cab service Dapoli offers affordable travel options for tourists and locals. Customers can book budget-friendly rides for beach visits and sightseeing. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Affordable Cab Service Dapoli",
description: "Affordable cab service Dapoli provides cost-effective travel solutions for beach trips and Konkan tours. Customers can book economical rides for local and outstation travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Dapoli Cab for Beach Trip",
description: "Dapoli cab for beach trip offers convenient travel to popular beaches and tourist spots. Customers can book cabs for one day or multi-day tours. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with beach trip cab services."
},
{
name: "Dapoli Cab for Sightseeing",
description: "Dapoli cab for sightseeing provides comfortable travel for exploring Konkan attractions. Customers can visit beaches, temples and scenic places easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with sightseeing cab services."
},
{
name: "Dapoli Cab for Outstation",
description: "Dapoli cab for outstation offers reliable travel for long-distance trips and tours. Customers can book cabs for Konkan and Maharashtra travel. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
},
{
name: "Cab Service Dapoli Maharashtra",
description: "Cab service Dapoli Maharashtra provides dependable transportation for local and tourist travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service Dapoli Maharashtra",
description: "Taxi service Dapoli Maharashtra offers reliable transportation for beach visits and local travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Booking Dapoli Online",
description: "Cab booking Dapoli online provides quick and easy reservation options for tourists. Users can book rides anytime for travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Innova Cab on Rent in Dapoli",
description: "Innova cab on rent in Dapoli offers spacious SUV travel for families and groups. Customers can book vehicles for beach trips and tours. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Ideal for long-distance travel. Travel easily with Innova cab services."
},
{
name: "Innova Crysta Cab on Rent in Dapoli",
description: "Innova Crysta cab on rent in Dapoli provides premium SUV travel for comfort and luxury. Customers can enjoy spacious seating and smooth rides. Professional drivers ensure safe journeys. Ideal for family vacations and tours. Transparent pricing ensures value. Travel easily with Innova Crysta services."
},
{
name: "Ertiga Cab on Rent in Dapoli",
description: "Ertiga cab on rent in Dapoli offers comfortable 7 seater travel for families and small groups. Customers can book vehicles for sightseeing and tours. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga cab services."
},
{
name: "Dzire Cab on Rent in Dapoli",
description: "Dzire cab on rent in Dapoli provides affordable sedan travel for local and outstation trips. Customers can book vehicles for comfortable journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan cab services."
},
{
name: "Sedan Cab on Rent in Dapoli",
description: "Sedan cab on rent in Dapoli offers budget-friendly travel for daily and sightseeing journeys. Customers can book vehicles for flexible trips. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan services."
},
{
name: "Luxury Cab Dapoli",
description: "Luxury cab Dapoli provides premium travel experience for tourists and family vacations. Customers can enjoy high-end vehicles and comfort. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with luxury cab services."
},
{
name: "Tempo Traveller on Rent in Dapoli",
description: "Tempo traveller on rent in Dapoli offers group travel solutions for beach trips and Konkan tours. Customers can book vehicles for family and corporate outings. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller services."
},
{
name: "Urbania on Rent Dapoli",
description: "Urbania on rent Dapoli provides luxury group travel for large families and tourist groups. Customers can book premium vehicles for long-distance journeys. Professional drivers ensure safe travel. Spacious seating enhances comfort. Flexible booking options are available. Travel easily with Urbania services."
},
{
name: "Best Cab Service in Dapoli for Beach Sightseeing",
description: "Best cab service in Dapoli for beach sightseeing offers reliable travel for exploring Konkan coast. Customers can visit beaches and tourist spots easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Affordable Cab Service Dapoli for Konkan Trip",
description: "Affordable cab service Dapoli for Konkan trip provides cost-effective travel for long-distance tours. Customers can explore Konkan destinations comfortably. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Dapoli Cab Service for Family Vacation",
description: "Dapoli cab service for family vacation offers comfortable travel for holidays and outings. Customers can book spacious vehicles for group travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with family cab services."
},
{
name: "Reliable Taxi Service Dapoli Maharashtra",
description: "Reliable taxi service Dapoli Maharashtra provides dependable transportation for tourists and locals. Customers can book taxis for daily and outstation travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
}
],

tableData: [
["Best Cab Service in Dapoli","Cheap Cab Service Dapoli"],
["Affordable Cab Service Dapoli","Dapoli Cab for Beach Trip"],
["Dapoli Cab for Sightseeing","Dapoli Cab for Outstation"],
["Cab Service Dapoli Maharashtra","Taxi Service Dapoli Maharashtra"],
["Cab Booking Dapoli Online","Innova Cab on Rent in Dapoli"],
["Innova Crysta Cab on Rent in Dapoli","Ertiga Cab on Rent in Dapoli"],
["Dzire Cab on Rent in Dapoli","Sedan Cab on Rent in Dapoli"],
["Luxury Cab Dapoli","Tempo Traveller on Rent in Dapoli"],
["Urbania on Rent Dapoli","Dapoli Cab Service for Family Vacation"]
],



whychoose: [
  {
    WhyChooseheading: "Reliable Cab Service in Dapoli",
    WhyChoosedescription: "SRS Cab Service offers dependable cab service in Dapoli for local sightseeing, beach travel, airport transfers, and outstation trips with experienced drivers and smooth booking."
  },
  {
    WhyChooseheading: "Affordable & Transparent Pricing",
    WhyChoosedescription: "We provide budget-friendly cab service in Dapoli with transparent pricing. Customers receive complete fare details including tolls and driver charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab & Taxi Availability",
    WhyChoosedescription: "Our Dapoli cab service operates 24/7, making it convenient for early morning travel, late-night pickups, Konkan tours, and emergency bookings."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options Available",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and luxury vehicles for all travel needs."
  },
  {
    WhyChooseheading: "Comfortable & Well-Maintained Vehicles",
    WhyChoosedescription: "All vehicles are clean, air-conditioned, and regularly serviced to ensure maximum comfort and safety during long coastal journeys."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Dapoli Area",
    WhyChoosedescription: "We provide quick pickup from homes, hotels, resorts, beaches, and nearby areas like Murud, Harnai, Karde Beach, and Anjarle."
  },
  {
    WhyChooseheading: "Best for Konkan & Beach Travel",
    WhyChoosedescription: "Our Dapoli cab service is ideal for beach tours, family trips, temple visits, and Konkan travel with scenic and comfortable rides."
  },
  {
    WhyChooseheading: "Trusted Cab Service in Dapoli",
    WhyChoosedescription: "SRS Cab Service is trusted by tourists and locals for punctual service, professional drivers, and reliable travel experience in the Konkan region."
  }
]
}

const faqData = [
  { 
    question: "Do you provide cab service in Dapoli?", 
    answer: "Yes, SRS Cab Service offers reliable cab service in Dapoli for local travel, beach sightseeing, and outstation trips. Our services are suitable for tourists, families, and group travel." 
  },
  { 
    question: "Is taxi service available 24 hours in Dapoli?", 
    answer: "Yes, our taxi service in Dapoli operates 24/7. You can book a cab anytime for early morning travel, late-night pickups, or emergency rides." 
  },
  { 
    question: "Do you provide cab for beach sightseeing in Dapoli?", 
    answer: "Yes, we provide cab service for visiting popular beaches like Murud Beach, Karde Beach, Ladghar Beach, and nearby tourist spots." 
  },
  { 
    question: "Which areas do you cover near Dapoli?", 
    answer: "We cover Murud, Harnai, Karde, Anjarle, Ladghar, and nearby Konkan areas for local and outstation travel." 
  },
  { 
    question: "Which vehicles are available in Dapoli cab service?", 
    answer: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and luxury vehicles for different travel needs." 
  },
  { 
    question: "Can I book cab online in Dapoli?", 
    answer: "Yes, you can easily book cab service in Dapoli online or via phone with quick confirmation and easy booking process." 
  },
  { 
    question: "Do you provide outstation cab service from Dapoli?", 
    answer: "Yes, we provide outstation cab services from Dapoli to Pune, Mumbai, Ratnagiri, Ganpatipule, and other destinations." 
  },
  { 
    question: "Is cab service suitable for family trips in Dapoli?", 
    answer: "Yes, we provide spacious vehicles like Ertiga, Innova, and Tempo Travellers which are perfect for family and group travel." 
  },
  { 
    question: "Are cab fares affordable in Dapoli?", 
    answer: "Yes, we offer affordable cab service in Dapoli with transparent pricing and no hidden charges." 
  },
  { 
    question: "Are vehicles clean and drivers professional?", 
    answer: "Yes, all vehicles are regularly cleaned and sanitized, and our drivers are trained, experienced, and verified for safe travel." 
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Patil",
    feedback:
      "Booked cab in Dapoli for beach sightseeing. The driver was very helpful and knew all local spots. The journey was comfortable and enjoyable.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Kulkarni",
    feedback:
      "Best cab service in Dapoli. We used it for family trip and everything was perfect. Clean car, professional driver, and reasonable pricing.",
    rating: 5
  }
];




















const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SRS Cab - Dapoli Cab Service",
  "description": "Reliable cab service in Dapoli, Maharashtra with SRS Cab. Book taxis for beach trips, sightseeing, outstation trips, and family vacations. 24/7 service with Innova, Innova Crysta, Ertiga, Dzire, sedan, luxury, tempo traveller, and Urbania cab options.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Dapoli",
    "addressLocality": "Dapoli",
    "addressRegion": "Maharashtra",
    "postalCode": "415712",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "17.7580",
    "longitude": "73.1080"
  },
  "url": "https://www.srscabservice.com/dapoli-cab-service",
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 00:00-23:59",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1475"
  },
  "areaServed": {
    "@type": "City",
    "name": "Dapoli, Maharashtra"
  }
};





  return (
    <div>
      


<Helmet>
  <title>Cab Service in Dapoli | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book reliable cab service in Dapoli, Maharashtra with SRS Cab. Beach trips, sightseeing, outstation trips, and family vacations available 24/7. Innova, Ertiga, sedan, luxury, tempo traveller, and Urbania cabs." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/97.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceindapoli;